import { doc, Timestamp, onSnapshot, setDoc } from "firebase/firestore";
import { useState, useEffect, useCallback } from "react";
import { v4 as uuid } from "uuid";
import { db } from "../firebase";

export type Person = {
  id: string;
  name: string;
  hasGone: boolean;
  createdAt: Timestamp;
};
const peopleDocRef = doc(db, "people", "index");

export const usePeople = () => {
  const [people, setPeople] = useState<Person[]>([]);

  useEffect(() => {
    return onSnapshot(peopleDocRef, (snapshot) => {
      setPeople(snapshot.data().people);
    });
  }, []);

  const updatePerson = useCallback(
    async (id: string, updates: Partial<Person>) => {
      await setDoc(peopleDocRef, {
        people: people.map((p) => {
          if (p.id === id) {
            return {
              ...p,
              ...updates,
            };
          } else {
            return p;
          }
        }),
      });
    },
    [people, setPeople]
  );

  const addPerson = useCallback(
    async (data: Omit<Person, "id" | "createdAt">) => {
      await setDoc(peopleDocRef, {
        people: [
          ...people,
          {
            ...data,
            id: uuid(),
            createdAt: Timestamp.now(),
          },
        ],
      });
    },
    [people, setPeople]
  );

  const removePerson = useCallback(
    async (id: string) => {
      await setDoc(peopleDocRef, {
        people: people.filter((p) => p.id !== id),
      });
    },
    [people, setPeople]
  );

  const updateAllPeople = useCallback(
    async (data: Partial<Omit<Person, "id" | "name" | "createdAt">>) => {
      await setDoc(peopleDocRef, {
        people: people.map((p) => ({ ...p, ...data })),
      });
    },
    [people, setPeople]
  );

  return {
    people,
    updatePerson,
    addPerson,
    removePerson,
    updateAllPeople,
  };
};
